<template>
    <div class="">

<!-- preloader start -->

<div id="ht-preloader">
  <div class="clear-loader">
      <div class="loader"></div>
  </div>
</div>

<!-- preloader end -->

<div class="mouse-cursor cursor-outer"></div>
<div class="mouse-cursor cursor-inner"></div>


<!--header start-->

<header id="site-header" class="header">
  <div id="header-wrap">
    <div class="container-fluid pr-lg-0 pl-lg-5">
      <div class="row">
        <div class="col-lg-12">
          <!-- Navbar -->
          <nav class="navbar navbar-expand-lg">
            <router-link tag='a' class="navbar-brand logo" to="/">
              <img class="img-fluid" src="images/logo.png" alt="">
            </router-link>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation"> <span></span>
              <span></span>
              <span></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNavDropdown">
              <ul class="navbar-nav ml-auto mr-auto">
                <!-- Home -->
                <li class="nav-item dropdown"> <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown">Home</a>
                  <div class="dropdown-menu">
                    <ul class="list-unstyled">
                      <li><router-link to='/' tag='a'>Home</router-link>
                      </li>
                      <li><router-link to="home2">Home 2</router-link>
                      </li>
                      <li><router-link to="home3">Home 3</router-link>
                      </li>
                      <li><router-link to="home4">Home 4</router-link>
                      </li>
                      <li><router-link to="home5">Home 5</router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="nav-item dropdown"> <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown">Shop</a>
                  <div class="dropdown-menu">
                    <ul class="list-unstyled">
                      <li><router-link to='/product-grid' tag='a'>product-grid</router-link>
                      </li>
                      <li><router-link to='/product-list' tag='a'>product-list</router-link>
                      </li>
                      <li><router-link to='/product-single' tag='a'>product-single</router-link>
                      </li>
                      <li><router-link to='/product-cart' tag='a'>Shopping Cart</router-link>
                      </li>
                      <li><router-link to='/product-checkout' tag='a'>Checkout</router-link>
                      </li>
                      <li><router-link to='/order-complete' tag='a'>Order Complete</router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="nav-item dropdown"> <a class="nav-link active dropdown-toggle" href="#" data-toggle="dropdown">Pages</a>
                  <div class="dropdown-menu">
                    <ul class="list-unstyled">
                      <li class="dropdown dropdown-submenu"> <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                      About Us
                    </a>
                        <ul class="dropdown-menu">
                          <li><router-link to='about' tag='a'>About</router-link>
                          </li>
                          <li><router-link to='about2' tag='a'>About 2</router-link>
                          </li>
                        </ul>
                      </li>
                      <li class="dropdown dropdown-submenu"> <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                      Team
                    </a>
                        <ul class="dropdown-menu">
                          <li><router-link to='team' tag='a'>team</router-link>
                          </li>
                          <li><router-link to='team2' tag='a'>team2</router-link>
                          </li>
                        </ul>
                      </li>
                      <li class="dropdown dropdown-submenu"> <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                      Case Studies
                    </a>
                        <ul class="dropdown-menu">
                          <li><router-link to='case-studies' tag='a'>case-studies</router-link>
                          </li>
                          <li><router-link to='case-studies-single' tag='a'>case-studies-single</router-link>
                          </li>
                        </ul>
                      </li>
                      <li class="dropdown dropdown-submenu"> <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                      Element
                    </a>
                        <ul class="dropdown-menu">
                          <li><router-link to='shortcode-accordion' tag=a>accordion</router-link>
                          </li>
                          <li><router-link to='shortcode-blog-post' tag=a>blog post</router-link>
                          </li>
                          <li><router-link to='shortcode-counter' tag=a>counter</router-link>
                          </li>
                          <li><router-link to='shortcode-feature' tag=a>feature</router-link>
                          </li>
                          <li><router-link to="shortcode-team" tag='a'>team</router-link>
                          </li>
                          <li><router-link to='shortcode-testmonials' tag=a>testmonial</router-link>
                          </li>
                        </ul>
                      </li>
                      <li><router-link to="faq" tag='a'>Faq</router-link>
                      </li>
                      <li><router-link to="pricing" tag='a'>pricing</router-link>
                      </li>
                      <li><router-link to="comming-soon" tag='a'>comming soon</router-link>
                      </li>
                      <li><a href="error-404.html">404 Error</a>
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="nav-item dropdown"> <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown">Portfolio</a>
                  <div class="dropdown-menu">
                    <ul class="list-unstyled">
                      <li><router-link to='/portfoli-masonry' tag='a'>Portfolio Masonry</router-link>
                      </li>
                      <li><router-link to='/portfolio-fullwidth' tag='a'>Portfolio Fullwidth</router-link>
                      </li>
                      <li><router-link to="/portfolio-single" tag='a'>Portfolio Single</router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="nav-item dropdown"> <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown">Blogs</a>
                  <div class="dropdown-menu">
                    <ul class="list-unstyled">
                      <li><router-link to='/blog-grid-2' tag='a'>blog-grid-2</router-link>
                      </li>
                      <li><router-link to='/blog-grid-3' tag='a'>blog-grid-3</router-link>
                      </li>
                      <li><router-link to='/blog-left-sidebar' tag='a'>blog-left-sidebar</router-link>
                      </li>
                      <li><router-link to='/blog-right-sidebar' tag='a'>blog-right-sidebar</router-link>
                      </li>
                      <li><router-link to='/blog-single' tag='a'>blog-single</router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="nav-item dropdown"> <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown">Contact Us</a>
                  <div class="dropdown-menu">
                    <ul class="list-unstyled">
                      <li><router-link to='/contact' tag='a'>contact</router-link>
                      </li>
                      <li><router-link to='/contact2' tag='a'>contact 2</router-link>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
              <div class="right-nav align-items-center d-flex justify-content-end">
                <div>
                  <div class="cart"> <a href="#" id="header-cart-btn"><span class="cart-badge">2</span> <i class="flaticon-shopping-bag"></i></a>
                    <!-- Cart List Area Start -->
                    <ul class="cart-list">
                      <li>
                        <a href="#" class="image">
                          <img src="images/product/01.jpg" class="img-fluid cart-thumb" alt="">
                        </a>
                        <div class="cart-item-desc">
                          <h6><a href="#">Women's Fashion</a></h6>
                          <p>1x - <span class="price">$132</span>
                          </p>
                        </div>
                      </li>
                      <li>
                        <a href="#" class="image">
                          <img src="images/product/02.jpg" class="img-fluid cart-thumb" alt="">
                        </a>
                        <div class="cart-item-desc">
                          <h6><a href="#">Watch</a></h6>
                          <p>1x - <span class="price">$28</span>
                          </p>
                        </div>
                      </li>
                      <li class="total d-flex justify-content-between align-items-center"><span>Total:</span> 
                        <h6 class="mb-0"> $160.00</h6>
                      </li>
                      <li><a href="product-cart.html" class="btn btn-theme"><span>Cart</span></a>
                        <a href="product-checkout.html" class="btn btn-theme"><span>Checkout</span></a>
                      </li>
                    </ul>
                  </div>
                </div> 
                <!-- <a class="btn btn-sm btn-outline-light mr-3 ml-lg-5" href="#">Hire Me</a> -->
                <router-link class="btn btn-sm btn-outline-light mr-3 ml-lg-5" tag="a" to='contact'>Hire Me</router-link>
              </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
</header>

<!--header end-->


    </div>
</template>

<script>
export default {
    name: "Header",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
